<template>
  <nav
    class="nav-bar mt-8 items-center justify-between py-5 md:flex md:bg-transparent md:py-0"
  >
    <slot></slot>
  </nav>
</template>
